export abstract class MenuDragPanelBase {
}
